import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import play1 from "assets/images/home/play.svg"
import play from "assets/images/circle-bg.png"
import { get } from "api/axios"
import endpoints from "api/endpoints"
import { Link } from "react-router-dom"
import ShuffleText from "components/animation/ShullfeText/ShullfeText"
import AnimatedText from "components/animation/AnimatedText/AnimatedText"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { toast, Bounce } from "react-toastify"

const HowDockTokkWorks = () => {
  const { isAuth } = useSelector(state => state.auth)
  const navigate = useNavigate()

  const handleJoinClick = () => {
    if (isAuth) {
      navigate("/dashboard")
    } else {
      toast.error("Please sign in to continue", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      navigate("/login")
    }
  }
  const [blogs, setBlogs] = useState([])

  const contentHandler = async () => {
    const resp = await get(`${endpoints.blog}?page=1&limit=3&filter=featured`)
    if (resp?.data?.success) {
      setBlogs(resp?.data?.data)
    }
  }

  function getText(html) {
    var divContainer = document.createElement("div")
    divContainer.innerHTML = html
    return divContainer.textContent || divContainer.innerText || ""
  }

  useEffect(() => {
    contentHandler()
  }, [])

  const buttonLabels = [
    "SUBSCRIBE ON SOCIAL MEDIA",
    "CONNECT YOUR ACCOUNT",
    "SIGN IN TO THE DOCKIES",
    "I’M READY TO POST MY JOKES",
  ]

  return (
    <section id="how-dock-tok-work" className="py-4 px-2 px-lg-3">
      <div className="px-2 px-lg-5 py-5">
        <h2 className="ff-cooper fw-normal font-size-56 text-uppercase pb-3 black-text-color pt-md-5">
          how dockies works
        </h2>
        <Row className="px-lg-5">
          <Col
            lg={1}
            md={2}
            className={
              "d-flex justify-content-center align-items-center d-sm-none d-md-none d-none  blog-text-container px-lg-4"
            }
          >
            <p
              className={
                " ff-cooper fw-normal font-size-80 text-uppercase vert_text"
              }
              style={{ color: "#AFDBC3", opacity: "50%" }}
            >
              We Are Dockies
            </p>
          </Col>
          <Col md={10} sm={12}>
            <Row className="pt-2 pb-2 w-100 ps-2 ps-md-5">
              {blogs.length > 0 ? (
                blogs.map((key, index) => {
                  let temp = index + 1
                  return (
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      key={index}
                      className="d-flex flex-column mb-4"
                    >
                      <div className="align-items-center  ms-sm-2 ms-lg-0 d-flex flex-column flex-sm-row   gap-4 py-2 custom-row-wrapper">
                        {temp % 2 == 0 && (
                          <div
                            style={{
                              maxHeight: "280px",
                              width: "220px",
                            }}
                            className={" d-none d-sm-none d-md-block"}
                          ></div>
                        )}
                        <div className="">
                          {/* col-12 ms-2 */}
                          <Link>
                            <div
                              className={`position-relative w-100 mt-md-3${
                                index === 1 ? "ms-md-4" : ""
                              }`}
                            >
                              {key?.videoDetail?.thumbnail?.path ? (
                                <img
                                  src={`${process.env.REACT_APP_S3_BUCKET}${key?.videoDetail?.thumbnail?.path}`}
                                  alt="blog"
                                  className="rounded-4   object-fit-cover blog-Img"
                                  style={{
                                    maxHeight: "280px",
                                    width:
                                      "clamp(110px, 87.8348px + 6.8836vw, 220px)",
                                  }}
                                />
                              ) : (
                                <video className="rounded w-100 h-100"></video>
                              )}
                              {/* Border Animation */}
                              <div className="border-animation responsive-margin">
                                <div
                                  className="circle1"
                                  style={{
                                    maxHeight: "310px",
                                    maxWidth:
                                      "clamp(130px, 105.8198px + 7.5094vw, 250px)",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </Link>
                        </div>

                        <div className="">
                          {/* col-12 */}
                          <Link
                            to={`/how-it-works-details/${key?._id}`}
                            className="d-flex flex-column flex-column-md flex-row-sm align-items-center"
                          >
                            <div className="  d-flex flex-column flex-column-md flex-row-sm">
                              <div className="ps-4">
                                <p
                                  style={{ color: "#AFDBC3" }}
                                  className={
                                    "font-size-56 ff-proxima fw-bolder mt-2 mt-lg-0"
                                  }
                                >
                                  0{temp}
                                </p>
                                <h3 className="ff-proxima font-size-32 fw-bolder text-uppercase  black-text-color mb-2">
                                  {getText(key.title).length > 80
                                    ? getText(key.title).slice(0, 80) + "..."
                                    : getText(key.title).slice(0, 80)}
                                </h3>
                                <p className=" ff-proxima font-size-16 gray-700">
                                  {getText(key.content).length > 200
                                    ? getText(key.content).slice(0, 200) + "..."
                                    : getText(key.content).slice(0, 200)}
                                </p>
                              </div>
                              {/* <button className="btn btn-primary-black-outline text-uppercase font-size-14 mb-3">
                                {buttonLabels[index]}
                              </button> */}
                            </div>
                          </Link>
                        </div>

                        {temp % 2 != 0 && (
                          <div
                            style={{
                              maxHeight: "280px",
                              width: "220px",
                            }}
                            className={" d-none d-sm-none d-md-block"}
                          ></div>
                        )}
                      </div>
                    </Col>
                  )
                })
              ) : (
                <h3 className="text-center">No Content Found!</h3>
              )}
              <Col xs={12} className={"text-center pt-lg-3"}>
                {" "}
                <button
                  className="text-uppercase font-size-14 btn btn-primary-yellow ff-proxima fw-bolder"
                  onClick={handleJoinClick}
                >
                  I want to be a Dockie
                </button>
              </Col>
            </Row>{" "}
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default HowDockTokkWorks
